export default __webpack_public_path__ + "static/AppBeers4-447094616da74267d144ec7f86e609d0.png";